import CfLoyalty from './CfLoyalty'

export * from './typings'

export default CfLoyalty
